import { Modal } from 'react-bootstrap'
import { toman } from 'utilities/helper/format'

/**
 * The one exit request nobody can accept: the member owes the fund.
 *
 * Their debt has to be paid before the membership can close, so this is a
 * dead end by design — but a dead end with the number on it. What stood here
 * before said only «حساب دفتری این عضو صفر نیست، به اپلیکیشن اندروید مراجعه
 * کنید», which was both vague and, for every other case, wrong: the PWA can
 * finish those itself now.
 */
export default function SettlementDebtModal({
    show,
    onHide,
    name,
    amount,
}: {
    show: boolean
    onHide: () => void
    name: string
    amount: number
}) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full px-4 py-4 text-center text-sm">
                <p className=" my-2 leading-6">
                    {name} هنوز {toman(amount)} به صندوق بدهکار است. تا وقتی این
                    بدهی تسویه نشود، خروج ایشان ممکن نیست.
                </p>
                <hr />
                <p className=" my-2 text-green-1" onClick={onHide}>
                    بستن
                </p>
            </div>
        </Modal>
    )
}
